export const USER_AFFILIATIONS = [
  'College Student',
  'Faculty/Staff',
  'Other',
] as const;

export type UserAffiliation = typeof USER_AFFILIATIONS[number];

export enum Affiliation {
  'College Student',
  'Faculty/Staff',
  'Other',
}
